import React from 'react'

const MyBenefits = () => {
  return (
    <div>MyBenefits</div>
  )
}

export default MyBenefits